import { customFunc } from 'shared/constants.json';

const buildCustomFuncPred = ({
  customFuncName,
  alias = undefined,
  attr = undefined,
  uid = undefined,
  args = [],
}) => ({
  alias,
  attr,
  customFunc: {
    name: customFuncName,
    uid,
    args,
  },
});
export const buildCustomFuncProgressCoursePred = ({
  alias = undefined,
  attr = undefined,
  timeSeries = [],
} = { alias: undefined, attr: undefined, timeSeries: [] }) => buildCustomFuncPred({
  customFuncName: customFunc.progressCourse,
  alias,
  attr,
  args: timeSeries.map((t) => ({ value: t })),
});

export const buildCustomFuncUpdateParticipationListPred = ({
  alias = undefined,
  attr = undefined,
  rangeStart = '',
  timeSeries = [],
}) => buildCustomFuncPred({
  customFuncName: customFunc.updateParticipationList,
  alias,
  attr,
  args: [{ value: JSON.stringify(rangeStart === '' ? {} : { from: rangeStart }) }, ...timeSeries.map((t) => ({ value: t }))],
});

// Args are positional: [0] bounded progress flag, [1..] time series dates.
// Backend source of truth: parseProgressCourseListArgs (progresscourselist_extension.go).
export const buildCustomFuncProgressCourseListPred = ({
  alias = undefined,
  attr = undefined,
  timeSeries = [],
  useBoundedProgress = true,
}) => buildCustomFuncPred({
  customFuncName: customFunc.progressCourseList,
  alias,
  attr,
  args: [{ value: String(useBoundedProgress) }, ...timeSeries.map((t) => ({ value: t }))],
});

// Args are positional: [0] bounded progress flag, [1] groupBy value, [2] optional compareTo date.
// Backend source of truth: boundedProgressParam/groupByParams/compareToParams (insights_extension.go).
export const buildCustomFuncGoalInsightsPred = ({
  alias = undefined,
  attr = undefined,
  groupBy,
  timeSeries = [],
  useBoundedProgress = true,
}) => buildCustomFuncPred({
  customFuncName: customFunc.goalInsights,
  alias,
  attr,
  uid: groupBy.uid,
  args: [{ value: String(useBoundedProgress) }, { value: groupBy.value }, ...timeSeries.map((t) => ({ value: t }))],
});
